import React, { useState, useEffect, useCallback } from "react";

import { Typography, Box, Paper, Button, CssBaseline } from "@material-ui/core";

import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/styles";
import Wlcm from "./../../../assets/svg/welcome.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },

  btn: {
    textTransform: "lowercase",
  },

  paper: {
    padding: 30,
  },
  action: {
    borderRadius: 15,
  },
}));

function Welcome(props) {
  const classes = useStyles();
  const history = useHistory();

  const { full } = props;

  return (
    <div className={full ? classes.root2 : classes.root}>
      <CssBaseline />
      <Paper elevation={0} className={classes.paper}>
        <Box
          m={7}
          p={7}
          border={0}
          borderRadius="borderRadius"
          classname={"root"}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          height={1}
        >
          <img src={Wlcm} height={200} alt="Welcome" />
          <Box p={2} />
          <Typography variant="h4">
            Welcome to SafariBus platform
          </Typography>
          <Box p={1} />
          <Typography align="center" color="textSecondary" gutterBottom>
            You can browse from the menu in the left part for what you can do, and feel free to contact us for any issue you might face.
          </Typography>
         
         <Box mt={3}><Typography>Centrika team</Typography></Box>
        </Box>
      </Paper>
    </div>
  );
}

export default withLocalize(Welcome);
